module.exports = __webpack_public_path__ + "static/media/system-notification-close.f886d8ff.svg";